unit View.Cidade.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCidadeEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbID: TLabel;
    edID: TDBEdit;
    lbNome: TLabel;
    edNome: TDBEdit;
    lbCodigoIBGE: TLabel;
    edCodigoIBGE: TDBEdit;
    lbDistrito: TLabel;
    edDistrito: TDBEdit;
    lbUF_Id: TLabel;
    edUF_Id: TDBEdit;
    XDataClientCidadeGet: TXDataWebClient;
    XDataClientCidadeDelete: TXDataWebClient;
    CidadeDataset: TXDataWebDataSet;
    CidadeDatasetID: TIntegerField;
    CidadeDatasetNome: TStringField;
    CidadeDatasetCodigoIBGE: TIntegerField;
    CidadeDatasetDistrito: TBooleanField;
    CidadeDatasetUF_Id: TIntegerField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCidadeGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCidadeDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCidadeDeleteError(Error: TXDataClientError);
    procedure CidadeDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCidadeEdit: TFViewCidadeEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCidadeEdit }

procedure TFViewCidadeEdit.btSaveClick(Sender: TObject);
begin
  if CidadeDataset.State in dsEditModes then
  begin
        CidadeDataset.Post;
    CidadeDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCidadeEdit.btDeleteClick(Sender: TObject);
begin
  if CidadeDataset.State in dsEditModes then
    CidadeDataset.Post;
  XDataClientCidadeDelete.Delete(CidadeDataset.EntitySetName,
    TJSObject(CidadeDataset.CurrentData));
end;


class function TFViewCidadeEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCidadeEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCidadeEdit.InsertEntity;
begin
  CidadeDataset.Close;
  CidadeDataset.SetJsonData('{}');
  CidadeDataset.Open;
  CidadeDataset.Insert;
end;

class function TFViewCidadeEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCidadeEdit(AForm).FInserting := AInserting;
    TFViewCidadeEdit(AForm).FId := AId;
    TFViewCidadeEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCidadeEdit(AForm).InsertEntity
    else
      TFViewCidadeEdit(AForm).LoadEntity;
    TFViewCidadeEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCidadeEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCidadeEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CidadeDataset.Connection.Model.DefaultSchema.FindEntityType(
      CidadeDataset.EntitySetName
    )
  );
  XDataClientCidadeGet.Get(CidadeDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCidadeEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCidadeEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCidadeEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCidadeEdit.XDataClientCidadeGetLoad(Response: TXDataClientResponse);
begin
  CidadeDataset.Close;
  CidadeDataset.SetJsonData(Response.Result);
  CidadeDataset.Open;
  
  CidadeDataset.Edit;  
end;

procedure TFViewCidadeEdit.XDataClientCidadeDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCidadeEdit.XDataClientCidadeDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCidadeEdit.CidadeDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCidadeEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCidadeEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cidade.form.message');
  lbMessage := TLabel.Create('view.cidade.form.message.label');
  btCloseMessage := TButton.Create('view.cidade.form.message.button');
  btCancel := TButton.Create('view.cidade.form.btBack');
  btSave := TButton.Create('view.cidade.form.btSave');
  btDelete := TButton.Create('view.cidade.form.btDelete');
  lbID := TLabel.Create('view.cidade.form.lbID');
  edID := TDBEdit.Create('view.cidade.form.edID');
  lbNome := TLabel.Create('view.cidade.form.lbNome');
  edNome := TDBEdit.Create('view.cidade.form.edNome');
  lbCodigoIBGE := TLabel.Create('view.cidade.form.lbCodigoIBGE');
  edCodigoIBGE := TDBEdit.Create('view.cidade.form.edCodigoIBGE');
  lbDistrito := TLabel.Create('view.cidade.form.lbDistrito');
  edDistrito := TDBEdit.Create('view.cidade.form.edDistrito');
  lbUF_Id := TLabel.Create('view.cidade.form.lbUF_Id');
  edUF_Id := TDBEdit.Create('view.cidade.form.edUF_Id');
  DataSource := TDataSource.Create(Self);
  CidadeDataset := TXDataWebDataSet.Create(Self);
  CidadeDatasetID := TIntegerField.Create(Self);
  CidadeDatasetNome := TStringField.Create(Self);
  CidadeDatasetCodigoIBGE := TIntegerField.Create(Self);
  CidadeDatasetDistrito := TBooleanField.Create(Self);
  CidadeDatasetUF_Id := TIntegerField.Create(Self);
  XDataClientCidadeGet := TXDataWebClient.Create(Self);
  XDataClientCidadeDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbID.BeforeLoadDFMValues;
  edID.BeforeLoadDFMValues;
  lbNome.BeforeLoadDFMValues;
  edNome.BeforeLoadDFMValues;
  lbCodigoIBGE.BeforeLoadDFMValues;
  edCodigoIBGE.BeforeLoadDFMValues;
  lbDistrito.BeforeLoadDFMValues;
  edDistrito.BeforeLoadDFMValues;
  lbUF_Id.BeforeLoadDFMValues;
  edUF_Id.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CidadeDataset.BeforeLoadDFMValues;
  CidadeDatasetID.BeforeLoadDFMValues;
  CidadeDatasetNome.BeforeLoadDFMValues;
  CidadeDatasetCodigoIBGE.BeforeLoadDFMValues;
  CidadeDatasetDistrito.BeforeLoadDFMValues;
  CidadeDatasetUF_Id.BeforeLoadDFMValues;
  XDataClientCidadeGet.BeforeLoadDFMValues;
  XDataClientCidadeDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCidadeEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 400;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 340;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 340;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 340;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbID.SetParentComponent(Self);
    lbID.Name := 'lbID';
    lbID.Left := 24;
    lbID.Top := 192;
    lbID.Width := 14;
    lbID.Height := 13;
    lbID.Caption := 'ID:';
    lbID.Transparent := True;
    edID.SetParentComponent(Self);
    edID.Name := 'edID';
    edID.Left := 221;
    edID.Top := 189;
    edID.Width := 200;
    edID.Height := 21;
    edID.Enabled := True;
    edID.TabOrder := 6;
    edID.Text := 'edID';
    edID.DataField := 'ID';
    edID.DataSource := DataSource;
    lbNome.SetParentComponent(Self);
    lbNome.Name := 'lbNome';
    lbNome.Left := 24;
    lbNome.Top := 219;
    lbNome.Width := 14;
    lbNome.Height := 13;
    lbNome.Caption := 'Nome:';
    lbNome.Transparent := True;
    edNome.SetParentComponent(Self);
    edNome.Name := 'edNome';
    edNome.Left := 221;
    edNome.Top := 216;
    edNome.Width := 200;
    edNome.Height := 21;
    edNome.Enabled := True;
    edNome.TabOrder := 7;
    edNome.Text := 'edNome';
    edNome.DataField := 'Nome';
    edNome.DataSource := DataSource;
    lbCodigoIBGE.SetParentComponent(Self);
    lbCodigoIBGE.Name := 'lbCodigoIBGE';
    lbCodigoIBGE.Left := 24;
    lbCodigoIBGE.Top := 246;
    lbCodigoIBGE.Width := 14;
    lbCodigoIBGE.Height := 13;
    lbCodigoIBGE.Caption := 'CodigoIBGE:';
    lbCodigoIBGE.Transparent := True;
    edCodigoIBGE.SetParentComponent(Self);
    edCodigoIBGE.Name := 'edCodigoIBGE';
    edCodigoIBGE.Left := 221;
    edCodigoIBGE.Top := 243;
    edCodigoIBGE.Width := 200;
    edCodigoIBGE.Height := 21;
    edCodigoIBGE.Enabled := True;
    edCodigoIBGE.TabOrder := 8;
    edCodigoIBGE.Text := 'edCodigoIBGE';
    edCodigoIBGE.DataField := 'CodigoIBGE';
    edCodigoIBGE.DataSource := DataSource;
    lbDistrito.SetParentComponent(Self);
    lbDistrito.Name := 'lbDistrito';
    lbDistrito.Left := 24;
    lbDistrito.Top := 273;
    lbDistrito.Width := 14;
    lbDistrito.Height := 13;
    lbDistrito.Caption := 'Distrito:';
    lbDistrito.Transparent := True;
    edDistrito.SetParentComponent(Self);
    edDistrito.Name := 'edDistrito';
    edDistrito.Left := 221;
    edDistrito.Top := 270;
    edDistrito.Width := 200;
    edDistrito.Height := 21;
    edDistrito.Enabled := True;
    edDistrito.TabOrder := 9;
    edDistrito.Text := 'edDistrito';
    edDistrito.DataField := 'Distrito';
    edDistrito.DataSource := DataSource;
    lbUF_Id.SetParentComponent(Self);
    lbUF_Id.Name := 'lbUF_Id';
    lbUF_Id.Left := 24;
    lbUF_Id.Top := 300;
    lbUF_Id.Width := 14;
    lbUF_Id.Height := 13;
    lbUF_Id.Caption := 'UF_Id:';
    lbUF_Id.Transparent := True;
    edUF_Id.SetParentComponent(Self);
    edUF_Id.Name := 'edUF_Id';
    edUF_Id.Left := 221;
    edUF_Id.Top := 297;
    edUF_Id.Width := 200;
    edUF_Id.Height := 21;
    edUF_Id.Enabled := True;
    edUF_Id.TabOrder := 10;
    edUF_Id.Text := 'edUF_Id';
    edUF_Id.DataField := 'UF_Id';
    edUF_Id.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := CidadeDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    CidadeDataset.SetParentComponent(Self);
    CidadeDataset.Name := 'CidadeDataset';
    CidadeDataset.AfterApplyUpdates := CidadeDatasetAfterApplyUpdates;
    CidadeDataset.EntitySetName := 'Cidade';
    CidadeDataset.Connection := DMConnection.ApiConnection;
    CidadeDataset.Left := 176;
    CidadeDataset.Top := 8;
    CidadeDatasetID.SetParentComponent(CidadeDataset);
    CidadeDatasetID.Name := 'CidadeDatasetID';
    CidadeDatasetID.FieldName := 'ID';
    CidadeDatasetID.Required := True;
    CidadeDatasetNome.SetParentComponent(CidadeDataset);
    CidadeDatasetNome.Name := 'CidadeDatasetNome';
    CidadeDatasetNome.FieldName := 'Nome';
    CidadeDatasetNome.Required := True;
    CidadeDatasetNome.Size := 255;
    CidadeDatasetCodigoIBGE.SetParentComponent(CidadeDataset);
    CidadeDatasetCodigoIBGE.Name := 'CidadeDatasetCodigoIBGE';
    CidadeDatasetCodigoIBGE.FieldName := 'CodigoIBGE';
    CidadeDatasetCodigoIBGE.Required := True;
    CidadeDatasetDistrito.SetParentComponent(CidadeDataset);
    CidadeDatasetDistrito.Name := 'CidadeDatasetDistrito';
    CidadeDatasetDistrito.FieldName := 'Distrito';
    CidadeDatasetDistrito.Required := True;
    CidadeDatasetUF_Id.SetParentComponent(CidadeDataset);
    CidadeDatasetUF_Id.Name := 'CidadeDatasetUF_Id';
    CidadeDatasetUF_Id.FieldName := 'UF_Id';
    CidadeDatasetUF_Id.Required := True;
    XDataClientCidadeGet.SetParentComponent(Self);
    XDataClientCidadeGet.Name := 'XDataClientCidadeGet';
    XDataClientCidadeGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCidadeGet, Self, 'OnLoad', 'XDataClientCidadeGetLoad');
    XDataClientCidadeGet.Left := 64;
    XDataClientCidadeGet.Top := 8;
    XDataClientCidadeDelete.SetParentComponent(Self);
    XDataClientCidadeDelete.Name := 'XDataClientCidadeDelete';
    XDataClientCidadeDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCidadeDelete, Self, 'OnLoad', 'XDataClientCidadeDeleteLoad');
    SetEvent(XDataClientCidadeDelete, Self, 'OnError', 'XDataClientCidadeDeleteError');
    XDataClientCidadeDelete.Left := 64;
    XDataClientCidadeDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbID.AfterLoadDFMValues;
    edID.AfterLoadDFMValues;
    lbNome.AfterLoadDFMValues;
    edNome.AfterLoadDFMValues;
    lbCodigoIBGE.AfterLoadDFMValues;
    edCodigoIBGE.AfterLoadDFMValues;
    lbDistrito.AfterLoadDFMValues;
    edDistrito.AfterLoadDFMValues;
    lbUF_Id.AfterLoadDFMValues;
    edUF_Id.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CidadeDataset.AfterLoadDFMValues;
    CidadeDatasetID.AfterLoadDFMValues;
    CidadeDatasetNome.AfterLoadDFMValues;
    CidadeDatasetCodigoIBGE.AfterLoadDFMValues;
    CidadeDatasetDistrito.AfterLoadDFMValues;
    CidadeDatasetUF_Id.AfterLoadDFMValues;
    XDataClientCidadeGet.AfterLoadDFMValues;
    XDataClientCidadeDelete.AfterLoadDFMValues;
  end;
end;

end.
